// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, GeoPoint, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCASBLZZz6hS1dBxZFekqLKqjQ8dld0fyQ",
  authDomain: "tonywebprorject.firebaseapp.com",
  projectId: "tonywebprorject",
  storageBucket: "tonywebprorject.appspot.com",
  messagingSenderId: "746026731414",
  appId: "1:746026731414:web:59a6eebb9fbaf157447fb7",
  measurementId: "G-WSENQQZDSL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with settings
const db = getFirestore(app);

// Enable offline persistence (optional but recommended)
if (typeof window !== 'undefined') {
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.warn('Persistence failed: Multiple tabs open');
    } else if (err.code === 'unimplemented') {
      console.warn('Persistence not available');
    }
  });
}

const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage, GeoPoint };



